module.exports = __webpack_public_path__ + "media/images/logos/Saint-Louis-University-08960386964a0938e63260d97d6e8ddd.svg";